import { gql } from '@apollo/client';

export const fetchTransactionAccountForChangeSubscriptionPane = gql`
  query fetchTransactionAccountForChangeSubscriptionPane($id: ID!) {
    transactionAccount(id: $id) {
      id
      billToPartyPricingEligibilty
      availableInvoiceGroups {
        nodes {
          id
          name
          currency
          shipToPriceEligibility
          purchaseOrder {
            number
            oneTimeUse
          }
          shipToParty {
            id
            name
            addressLine1
            addressLine2
            city
            state
            country
            postcode
            taxId
          }
          defaultPaymentMethod {
            id
            type
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
              }
            }
          }
        }
      }
    }
  }
`;
